module.exports = __webpack_public_path__ + "img/primary_7x2_z18.a122a8e0.svg";